import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';

import { withStyles } from '@material-ui/core/styles';

// REDUX
import { connect } from 'react-redux';
import { resetState } from '../actions';

// ICONS
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SearchIcon from '@material-ui/icons/Search';
import TuneIcon from '@material-ui/icons/Tune';

import Tooltip from '@material-ui/core/Tooltip';

// DRAWER
import MainDecorator from './MainDecorator';
import { Grid, Avatar, Menu, MenuItem, Drawer } from '@material-ui/core';

// SOME DESIGN VARIABLES
const sidebarWidth = '120px';
const sidebarBackgroundColor = '#172B4D';

const styles = theme => ({
  icon: {
    color: 'white',
    opacity: '0.4'
  },
  selectedIcon: {
    color: 'white',
    opacity: '1'
  },
  largeIcon: {
    height: '32px',
    width: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  logo: {
    width: '45px',
    marginTop: '14px'
  },
  drawer: {
    width: sidebarWidth,
    height: '100%'
  },
  drawerPaper: {
    background: sidebarBackgroundColor,
    alignItems: 'stretch',
    width: sidebarWidth,
    height: '100%',
    borderWidth: '0px'
  },
  sidebarIcons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%'
  },
  sidebarLogo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '33%'
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row'
  }
});

class SideBar extends Component {
  constructor (props) {
    super(props);
    const { classes } = this.props;

    let metrics = classes.icon;
    let dashboard = classes.icon;
    let settings = classes.icon;
    let search = classes.icon;

    const userRol = '';
    const username = '';
    const anchorEl = null;

    switch (this.props.location.pathname) {
      case '/metrics':
        metrics = classes.selectedIcon;
        break;
      case '/dashboard':
        dashboard = classes.selectedIcon;
        break;
      case '/settings':
        settings = classes.selectedIcon;
        break;
      case '/search':
        search = classes.selectedIcon;
        break;
      default:
        dashboard = classes.selectedIcon;
        break;
    }

    this.state = {
      metrics,
      dashboard,
      settings,
      search,
      userRol,
      username,
      anchorEl
    };
  }

  componentDidMount () {
    Auth.currentAuthenticatedUser({
      bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    })
      .then(user => {
        this.setState({
          username: user.username,
          userRol: user.signInUserSession.idToken.payload.role
        });
      })
      .catch(err => console.error(err));
  }

  handleLogOut = () => {
    Auth.signOut()
      .then(() => {
        this.props.Reset();
      })
      .catch(err => err);
    this.setState({
      ...this.state,
      anchorEl: null
    });
  };

  handleClick = event => {
    this.setState({
      ...this.state,
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      anchorEl: null
    });
  };

  handleOpacity = element => {
    const { classes } = this.props;

    let metrics = classes.icon;
    let dashboard = classes.icon;
    let settings = classes.icon;
    const search = classes.icon;

    switch (element) {
      case 'metrics':
        metrics = classes.selectedIcon;
        break;
      case 'dashboard':
        dashboard = classes.selectedIcon;
        break;
      case 'settings':
        settings = classes.selectedIcon;
        break;
      case 'search':
        settings = classes.selectedIcon;
        break;
      default:
        dashboard = classes.selectedIcon;
        break;
    }
    this.setState({
      metrics,
      dashboard,
      settings,
      search
    });
  };

  render () {
    const { classes } = this.props;
    const { metrics, dashboard, settings, search } = this.state;

    if (!this.props.configFile) {
      return <div />;
    }

    return (
      <div className={classes.mainContainer}>
        <Drawer
          className={classes.drawer}
          variant='permanent'
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <Grid
            container
            direction='row'
            justify='space-between'
            alignItems='stretch'
            spacing={0}
            style={{ height: '100%' }}
          >
            <Grid
              item
              xs={10}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                justifyContent: 'flex-start'
              }}
            >
              <div className={classes.sidebarLogo}>
                <img
                  src={this.props.configFile.logo}
                  alt='logo'
                  className={classes.logo}
                />
              </div>
              <div className={classes.sidebarIcons}>
                <Tooltip title='Métricas' placement='right'>
                  <Link
                    to='/metrics'
                    onClick={() => {
                      this.handleOpacity('metrics');
                    }}
                  >
                    <AssessmentOutlinedIcon
                      fontSize='large'
                      className={metrics}
                    >
                      Metrics
                    </AssessmentOutlinedIcon>
                  </Link>
                </Tooltip>
                <Tooltip title='Buscar' placement='right'>
                  <a target='_blank' href='/search' rel='noopener noreferrer'>
                    <SearchIcon fontSize='large' className={search}>
                      Search
                    </SearchIcon>
                  </a>
                </Tooltip>
                <Tooltip title='Dashboard' placement='right'>
                  <Link
                    to='/dashboard'
                    onClick={() => {
                      this.handleOpacity('dashboard');
                    }}
                  >
                    <DashboardIcon fontSize='large' className={dashboard}>
                      Dashboard
                    </DashboardIcon>
                  </Link>
                </Tooltip>
                {this.state.userRol === 'admin' && (
                  <Tooltip title='Configuración' placement='right'>
                    <Link
                      to='/settings'
                      onClick={() => {
                        this.handleOpacity('settings');
                      }}
                    >
                      <TuneIcon fontSize='large' className={settings}>
                        Settings
                      </TuneIcon>
                    </Link>
                  </Tooltip>
                )}
                <div>
                  <Tooltip
                    title={`Usuario: ${this.state.username} - Rol: ${this.state.userRol} `}
                    placement='right'
                  >
                    <Avatar
                      aria-controls='simple-menu'
                      onClick={this.handleClick}
                      style={{
                        marginBottom: '30px',
                        backgroundColor: 'transparent'
                      }}
                    >
                      <AccountCircleIcon fontSize='large' />
                    </Avatar>
                  </Tooltip>
                  <Menu
                    id='simple-menu'
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleClose}
                  >
                    <MenuItem onClick={this.handleLogOut}>Logout</MenuItem>
                  </Menu>
                </div>
              </div>
            </Grid>
            <Grid item xs={2}>
              <MainDecorator />
            </Grid>
          </Grid>
        </Drawer>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  Reset: () => dispatch(resetState())
});

export default connect(
  null,
  mapDispatchToProps
)(withRouter(withStyles(styles)(SideBar)));
